import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { db } from "../../server";
import { Layout } from "../../Globalstyles/Layout";
import Menu from "../../components/Menu";
import { Container } from "./styles";
import { BiPlus, BiTrash } from "react-icons/bi";
import { IsLoged } from "../../App";

export default function EditNotice() {
	const { id } = useParams();
	const [noticeExists, setNE] = useState(false);
	const [noticeInfo, setNoticeInfo] = useState({});
	const [articles, setArticles] = useState([]);

	const [newTitle, setNewTitle] = useState("");
	const [newDesc, setNewDesc] = useState("");
	const [newShortDesc, setNewShortDesc] = useState("");

	const [editArticles, setEditArticles] = useState(false);

	let navigate = useNavigate();

	useEffect(() => {
		if (!IsLoged()) return navigate("/login");
	});

	useEffect(() => {
		async function loadInfo() {
			try {
				const doc = await db.collection("noticias").doc(id).get();

				if (!doc.exists) {
					console.log("Notícia não encontrada");
				} else {
					setNE(true);
					const data = doc.data();
					setNoticeInfo(data);
					setArticles(data.articles || []);
				}
			} catch (err) {
				console.error("Erro ao buscar notícia:", err);
			}
		}

		if (id) loadInfo();
	}, [id]);

	function saveEdition() {
		const doc = db.collection("noticias").doc(id);

		const isTitleEdited = newTitle.trim() !== "";
		const isDescEdited = newDesc.trim() !== "";
		const isShortDescEdited = newShortDesc.trim() !== "";

		const originalArticles = JSON.stringify(noticeInfo.articles || []);
		const updatedArticles = JSON.stringify(articles);
		const isArticlesEdited = originalArticles !== updatedArticles;

		if (
			!isTitleEdited &&
			!isDescEdited &&
			!isShortDescEdited &&
			!isArticlesEdited
		) {
			alert("Nada foi alterado! \n\nVoltando para página de gerenciamento!");
			navigate("/noticeManagement");
			return;
		}

		if (isTitleEdited) noticeInfo.title = newTitle;
		if (isDescEdited) noticeInfo.description = newDesc;
		if (isShortDescEdited) noticeInfo.shortDesc = newShortDesc;
		if (isArticlesEdited) noticeInfo.articles = articles;

		const date = new Date();
		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const year = date.getUTCFullYear();
		const hours = String(date.getHours()).padStart(2, "0");
		const minutes = String(date.getMinutes()).padStart(2, "0");

		doc.set({
			...noticeInfo,
			edited: true,
			editionDate: `${day}/${month}/${year} - ${hours}:${minutes}`,
		});

		alert("Novas informações salvas!!");
		navigate("/noticeManagement");
	}

	function handleArticleChange(articleIdx, contentIdx, newValue) {
		setArticles((prev) =>
			prev.map((article, i) =>
				i === articleIdx
					? {
							...article,
							content: article.content.map((c, j) =>
								j === contentIdx ? newValue : c
							),
					  }
					: article
			)
		);
	}

	function handleArticleFieldChange(articleIdx, field, newValue) {
		setArticles((prev) =>
			prev.map((article, i) =>
				i === articleIdx ? { ...article, [field]: newValue } : article
			)
		);
	}

	function addContentToArticle(articleIdx) {
		setArticles((prev) =>
			prev.map((article, i) =>
				i === articleIdx
					? { ...article, content: [...article.content, ""] }
					: article
			)
		);
	}

	function removeContentFromArticle(articleIdx, contentIdx) {
		setArticles((prev) =>
			prev.map((article, i) =>
				i === articleIdx
					? {
							...article,
							content: article.content.filter((_, j) => j !== contentIdx),
					  }
					: article
			)
		);
	}

	return (
		<div className="app">
			<Layout className="layout">
				<Menu />

				{!noticeExists ? (
					<Container>
						<h1 id="nonContent">noticia não existe</h1>
					</Container>
				) : (
					<Container>
						<div className="input-area">
							<label htmlFor="title">Titulo</label>
							<input
								type="text"
								name="title"
								id="title"
								value={newTitle}
								placeholder={noticeInfo.title}
								onChange={(e) => setNewTitle(e.target.value)}
							/>
						</div>
						<div className="input-area">
							<label htmlFor="shortDescription">Resumo noticia</label>
							<textarea
								name="shortDescription"
								id="shortDescription"
								placeholder={noticeInfo.shortDesc}
								value={newShortDesc}
								onChange={(e) => setNewShortDesc(e.target.value)}
								maxLength={300}
							/>
						</div>
						<div className="input-area">
							<label htmlFor="description">Descrição</label>
							<textarea
								name="description"
								id="description"
								placeholder={noticeInfo.description}
								value={newDesc}
								onChange={(e) => setNewDesc(e.target.value)}></textarea>
						</div>

						{editArticles && (
							<div className="articles-area">
								<h1>Artigos:</h1>
								{Array.isArray(articles) &&
									articles.map((a, idx) => {
										const header = (
											<div className="articleHeader">
												<h2 key={`header-${idx}`}>Artigo {idx + 1}</h2>
											</div>
										);

										if (a.type === 1 || a.type === 2) {
											return (
												<div key={idx}>
													{header}
													<ul className={a.type === 2 ? "numeric" : "topic"}>
														<div className="input-area">
															<label htmlFor={`articleTitle-${idx}`}>
																Titulo do artigo
															</label>
															<input
																type="text"
																id={`articleTitle-${idx}`}
																value={a.name}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"name",
																		e.target.value
																	)
																}
															/>
														</div>
														<div className="input-area">
															<label htmlFor={`articleDesc-${idx}`}>
																Descrição do artigo
															</label>
															<textarea
																id={`articleDesc-${idx}`}
																value={a.description}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"description",
																		e.target.value
																	)
																}
															/>
														</div>
														{Array.isArray(a.content) &&
															a.content.map((item, iIdx) => (
																<li key={iIdx}>
																	<div>
																		<input
																			type="text"
																			value={item}
																			onChange={(e) =>
																				handleArticleChange(
																					idx,
																					iIdx,
																					e.target.value
																				)
																			}
																		/>
																		<button
																			id="trashButton"
																			onClick={() =>
																				removeContentFromArticle(idx, iIdx)
																			}>
																			<BiTrash />
																		</button>
																	</div>
																</li>
															))}
														<button
															id="plusbutton"
															onClick={() => addContentToArticle(idx)}>
															<BiPlus />
														</button>
													</ul>
												</div>
											);
										} else if (a.type === 3) {
											return (
												<div key={idx}>
													{header}
													<div className="paragraph-article">
														<div className="input-area">
															<label htmlFor={`articleTitle-${idx}`}>
																Título
															</label>
															<input
																type="text"
																id={`articleTitle-${idx}`}
																value={a.name}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"name",
																		e.target.value
																	)
																}
															/>
														</div>
														<div className="input-area">
															<label htmlFor={`articleText-${idx}`}>
																Parágrafo
															</label>
															<textarea
																id={`articleText-${idx}`}
																value={a.description}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"description",
																		e.target.value
																	)
																}
															/>
														</div>
													</div>
												</div>
											);
										} else if (a.type === 4) {
											return (
												<div key={idx}>
													{header}
													<div className="video-article">
														<div className="input-area">
															<label htmlFor={`videoTitle-${idx}`}>
																Título do vídeo
															</label>
															<input
																type="text"
																id={`videoTitle-${idx}`}
																value={a.name}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"name",
																		e.target.value
																	)
																}
															/>
														</div>
														<div className="input-area">
															<label htmlFor={`videoDesc-${idx}`}>
																Descrição do vídeo
															</label>
															<textarea
																id={`videoDesc-${idx}`}
																value={a.description}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"description",
																		e.target.value
																	)
																}
															/>
														</div>
														<div className="input-area">
															<label htmlFor={`videoLink-${idx}`}>
																Link do vídeo
															</label>
															<input
																type="text"
																id={`videoLink-${idx}`}
																value={a.content}
																onChange={(e) =>
																	handleArticleFieldChange(
																		idx,
																		"content",
																		e.target.value
																	)
																}
															/>
														</div>
													</div>
												</div>
											);
										}
										return null;
									})}
							</div>
						)}

						<div className="editArticles_button-area">
							<button onClick={() => setEditArticles(true)}>
								Editar Artigos
							</button>
						</div>
						<div>
							<button onClick={saveEdition}>Salvar</button>
						</div>
					</Container>
				)}
			</Layout>
		</div>
	);
}
